import * as React from "react"
import { Widget, fromJSX, Unit, any } from "widgets-for-react"
import { fakeButtonLabel, fakeButtonSecondaryLabel } from "../../config/fakeData"
import { StyleguideExample, StyleguidePart } from "../../utils/renderers"

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ObjectsButtons = (): Widget<Unit> =>
  any<Unit>([
    StyleguidePart({ title: 'Primary button', intro: '' })(
      StyleguideExample({ showExampleLabel: true, isFullScreen: false })(
        fromJSX((_) => (
          <>
            {ComponentButtonPrimary(false).run(_)}
          </>
        ))
      )
    ),
    StyleguidePart({ title: 'Primary button - Inverted', intro: '' })(
      StyleguideExample({ showExampleLabel: true, isFullScreen: false, extraClasses: "bg--orange" })(
        fromJSX((_) => (
          <>
            {ComponentButtonPrimary(true).run(_)}
          </>
        ))
      )
    ),
    StyleguidePart({ title: 'Primary button - Inverted', intro: '' })(
      StyleguideExample({ showExampleLabel: true, isFullScreen: false, extraClasses: "bg--black" })(
        fromJSX((_) => (
          <>
            {ComponentButtonPrimary(true).run(_)}
          </>
        ))
      )
    ),
    StyleguidePart({ title: 'Secondary button', intro: '' })(
      StyleguideExample({ showExampleLabel: true, isFullScreen: false })(
        fromJSX((_) => (
          <>
            {ComponentButtonSecondary(false).run(_)}
          </>
        ))
      )
    ),
    StyleguidePart({ title: 'Secondary button - Inverted', intro: '' })(
      StyleguideExample({ showExampleLabel: true, isFullScreen: false, extraClasses: "bg--orange" })(
        fromJSX((_) => (
          <>
            {ComponentButtonSecondary(true).run(_)}
          </>
        ))
      )
    ),
    StyleguidePart({ title: 'Secondary button - Inverted', intro: '' })(
      StyleguideExample({ showExampleLabel: true, isFullScreen: false, extraClasses: "bg--black" })(
        fromJSX((_) => (
          <>
            {ComponentButtonSecondary(true).run(_)}
          </>
        ))
      )
    )
  ])

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentButtonPrimary = (inverted: boolean): Widget<never> => fromJSX((_) => (
  <button className={`button button--primary${inverted ? '-inverted' : ''}`}>
    <span className="button__label">{fakeButtonLabel}</span>
  </button>
))

export const ComponentButtonSecondary = (inverted: boolean): Widget<never> => fromJSX((_) => (
  <button className={`button button--secondary${inverted ? '-inverted' : ''}`}>
    <span className="button__label">{fakeButtonSecondaryLabel}</span>
  </button>
))
